module.exports = __webpack_public_path__ + "static/img/4030_phase_function_Paper_Points.cb45932.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/4030_phase_function_Paper_Points.png
// module id = yWdR
// module chunks = 0